import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const HookComponentResource: React.FC = () => {
  const { setValue, watch, formState } = useFormContext();
  const annualCost = watch('annualCost');

  const getAndSetDailyCost = () => {
    if (formState.dirtyFields['annualCost']) {
      //220 sono i gg lavorativi in un anno, calcolati 11 mesi per 20gg mese
      const dailyCost = annualCost / 220;
      const hourCost = dailyCost / 8;
      setValue('dailyCost', dailyCost, { shouldDirty: true });
      setValue('hourCost', hourCost, { shouldDirty: true });
    }
  };

  useEffect(() => {
    getAndSetDailyCost();
  }, [annualCost]);

  return <div />;
};

export default HookComponentResource;
